import React from 'react';

const skillLevelOptions = [
  { value: '', label: '—' },
  { value: 0, label: 'Начальный' },
  { value: 1, label: 'Уверенный' },
  { value: 2, label: 'Продвинутый' },
];

export default function SkillLevelSelect({ value, onChange, style }) {
  return (
    <select value={value} onChange={onChange} style={style}>
      {skillLevelOptions.map(opt => (
        <option key={String(opt.value)} value={String(opt.value)}>{opt.label}</option>
      ))}
    </select>
  );
}


